import httpRequest from '../httpRequest'

export default {
  // 获取规则列表
  getList: {
    method: 'get',
    url: '/v1/cms/CommentShareRule'
  },

  // 获取规则详情
  getDetail: {
    fn: (id) => httpRequest.get(`/v1/cms/CommentShareRule/${id}`)
  },

  // 创建规则
  create: {
    method: 'post',
    url: '/v1/cms/CommentShareRule'
  },

  // 更新规则
  update: {
    fn: (id, data) => httpRequest.put(`/v1/cms/CommentShareRule/${id}`, data)
  },

  // 删除规则
  delete: {
    fn: (id) => httpRequest.delete(`/v1/cms/CommentShareRule/${id}`)
  },

  // 修改规则状态
  updateStatus: {
    fn: (id, data) => httpRequest.put(`/v1/cms/CommentShareRule/status/${id}`, data)
  },

  // 获取规则下的商品列表
  getRuleGoods: {
    fn: (ruleId, params) => httpRequest.get(`/v1/cms/CommentShareRule/${ruleId}/goods`, { params })
  },

  // 添加商品到规则
  addGoods: {
    fn: (ruleId, data) => httpRequest.post(`/v1/cms/CommentShareRule/${ruleId}/goods/add`, data)
  },

  // 从规则移除商品
  removeGoods: {
    fn: (ruleId, data) => httpRequest.post(`/v1/cms/CommentShareRule/${ruleId}/goods/remove`, data)
  },

  // 搜索商品
  searchGoods: {
    fn: (data) => {
      // 只发送接口文档定义的参数，避免额外参数
      const params = {}
      if (data.keyword) params.keyword = data.keyword
      if (data.page_index) params.page_index = data.page_index
      if (data.page_size) params.page_size = data.page_size
      return httpRequest.post('/v1/cms/CommentShareRule/search/goods', params)
    }
  }
}
